import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReservationService } from '../../core/services/reservation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ECancelReason } from '../../core/enum/ECancelReason';
import { EOriginStatus } from '../../core/enum/EOriginStatus';

@Component({
    selector: 'madero-confirm-reservation',
    imports: [MatIcon, MatProgressSpinnerModule],
    templateUrl: './confirm-reservation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './confirm-reservation.component.scss'
})
export class ConfirmReservationComponent implements OnInit {
  public loading = false;
  isConfirmed: any = null;
  errorService: any = false;
  body: any = {
    id: '',
    branchId: '',
    hallId: '',
    date: '',
    cancelReason: '',
    status: '',
    bookingOrigin: '',
    actor: '',
    quantity: '',
    hour: '',
  };
  // {
  //   "id": -var10-,
  //   "branchId": -var11-,
  //   "hallId": -var12-,
  //   "date": -var4-,
  //   "status": -var13-,
  //   "bookingOrigin": -var15-,
  //   "actor": -var14-,
  //   "quantity": -var6-,
  //   "hour": -var5-
  // }
  // /confirm?id=-var10-&branchId=-var11-&hallId=-var12-&date=-var4-&status=-var13-&bookingOrigin=-var15-&actor=-var14-&quantity=-var6-&hour=-var5-

  constructor(
    private route: ActivatedRoute,
    private reservationService: ReservationService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.onGetParamsReservation();
  }

  onGetParamsReservation(): void {
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      const branchId = params['branchId'];
      const hallId = params['hallId'];
      const date = params['date'];
      const status = params['status'];
      const bookingOrigin = params['bookingOrigin'];
      const actor = params['actor'];
      const quantity = params['quantity'];
      const hour = params['hour'];

      this.body = {
        id: id,
        branchId: branchId,
        hallId: hallId,
        date: this.parseDatePtBR(date),
        status: status,
        bookingOrigin: bookingOrigin,
        actor: actor,
        quantity: quantity,
        hour: hour,
      };

      setTimeout(() => {
        this.onPutReservation();
      }, 3000);
    });
  }

  parseDatePtBR(dateString: string): string {
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  }

  onPutReservation(): void {
    if (this.body.status == EOriginStatus.CANCELED) {
      this.body.cancelReason = ECancelReason.CLIENT;
    }
    this.reservationService.putReservation(this.body).subscribe({
      next: (statusReserv: any) => {
        this.onChangeFeedback();
        this.errorService = false;
      },
      error: (e) => {
        this.loading = false;
        const err = e.error.errors.map((i: any) => i.message)[0];

        this._snackBar.open(err, 'fechar');
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  onChangeFeedback(): void {
    if (this.body.status == EOriginStatus.CONFIRMED) {
      this.isConfirmed = true;
    } else if (this.body.status == EOriginStatus.CANCELED) {
      this.isConfirmed = false;
    }
  }
}
